module.exports = __webpack_public_path__ + "static/logo-osm-worldwide.0ce2047e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-osm-worldwide.png
// module id = 809
// module chunks = 222764574844450